export default function ({ store, error }) {
  if (!store.state.auth.user || !store.state.auth.user.is_active) {
    return error({ statusCode: 403, message: 'Доступ запрещен. Ваша почта должна быть подтверждена' })
  }
}
